import React from "react";
import PartTwoAfcPanel from "./PartTwoAfcPanel";
import SectionLoader from "../general/component/loading";

export default function SectionTwoAfc({
                                          jwtToken,
                                          twoAfcForm,
                                          twoAfcFormName,
                                          twoAfcVarOptions,
                                          onFormChange,
                                          onFormSubmit,
                                          twoAfcs,
                                          handleUpdate,
                                          showAlert,
                                          loading
}) {
    return (
        <section style={{ marginBottom: "40px" }}>
            <h2>Two-Alternative Forced Choice (2AFC)</h2>
            <hr style={{marginTop:"0px"}}/>
            {/* form for creating new 2AFC */}
            <div className="form-group" style={{width: "800px", marginBottom: "20px"}}>
                <form id="createTwoAfc">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Variable A</th>
                                <th>Variable B</th>
                                <th>Chosen Variable</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <input style={{width: "200px"}}
                                           className="form-control"
                                           type="text"
                                           name="name"
                                           placeholder="2AFC name..."
                                           value={twoAfcFormName}
                                           onChange={onFormChange}/>
                                </td>
                                <td>
                                    <select className="form-control"
                                            name="variableA"
                                            style={{width: "180px"}}
                                            value={twoAfcForm.variableA}
                                            onChange={onFormChange}>
                                        <option value="">---Select variable---</option>
                                        {twoAfcVarOptions}
                                    </select>
                                </td>
                                <td>
                                    <select className="form-control"
                                            name="variableB"
                                            style={{width: "180px"}}
                                            value={twoAfcForm.variableB}
                                            onChange={onFormChange}>
                                        <option value="">---Select variable---</option>
                                        {twoAfcVarOptions}
                                    </select>
                                </td>
                                <td>
                                    <select className="form-control"
                                            name="chosenVariable"
                                            style={{width: "180px"}}
                                            value={twoAfcForm.chosenVariable}
                                            onChange={onFormChange}>
                                        <option value="">---Select variable---</option>
                                        {twoAfcVarOptions}
                                    </select>
                                </td>
                                <td>
                                    <button type="submit"
                                            className="btn btn-primary"
                                            style={{paddingLeft:"30px", paddingRight:"30px"}}
                                            onClick={onFormSubmit}>CREATE</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
            {/* render all 2AFCs */}
            {loading ? (
                <SectionLoader />
            ) : twoAfcs && twoAfcs.length > 0 ? (
                <div style={{display: "flex", flexWrap: "wrap"}}>
                    {twoAfcs.map((twoAfc, index) => (
                        <PartTwoAfcPanel
                            key={twoAfc.id}
                            jwtToken={jwtToken}
                            twoAfcIndex={index}
                            twoAfcData={twoAfc}
                            handleUpdate={handleUpdate}
                            showAlert={showAlert}
                        />
                    ))}
                </div>
            ) : (
                <div className="alert alert-warning" style={{textAlign: "center"}}>
                    <strong>No 2AFCs created.</strong>
                </div>
            )}
        </section>
    );
}
